import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { catchError, EMPTY, Observable } from 'rxjs';

import { DEFAULT_LANGUAGE } from '~constants/translations';
import { TranslationService } from '~services/translation.service';
import { sentryError } from '~utils/sentry-error';

@Injectable({
  providedIn: 'root',
})
export class AppResolver implements Resolve<void> {
  protected readonly router = inject(Router);
  protected readonly translationService = inject(TranslationService);

  resolve(route: ActivatedRouteSnapshot): Observable<void> {
    const lang = route.paramMap.get('lang') || DEFAULT_LANGUAGE;

    return this.initializeLanguage(lang);
  }

  private initializeLanguage(lang: string): Observable<void> {
    return this.translationService.setLanguage(lang).pipe(
      catchError((error) => {
        sentryError(error, 'Failed to load initial translations', lang);

        return EMPTY;
      }),
    );
  }
}
